import React, { memo, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import styles from './styles.module.css'
import wheelImage from '../../../../images/wheel.png'
import wheelImageKz from '../../../../images/wheel_kz.png'
import wheelBgImage from '../../../../images/wheel_bg.png'
import wheelArrowImage from '../../../../images/wheel_arrow.png'
import wheelCrown from '../../../../images/wheel_crown.png'

interface WheelProps {
  isAnimate: boolean
  isOpenModal: number
  spinsCount: number
  disabled?: boolean
  onSpin: () => void
}

const Wheel: React.FC<WheelProps> = ({ isAnimate, spinsCount, disabled, onSpin }) => {
  const { i18n } = useTranslation();
  const [rotateBorderDegree, setRotateBorderDegree] = useState(0)

  useEffect(() => {
    if (isAnimate) {
      if (spinsCount === 4) return setRotateBorderDegree(4770)
      if (spinsCount === 3) return setRotateBorderDegree(9595)
    } else {
      let i = 0
      setRotateBorderDegree((prev) => prev - 5)
      const interval = setInterval(() => {
        if (i % 2 === 0) setRotateBorderDegree((prev) => prev + 10)
        if (i % 2 === 1) setRotateBorderDegree((prev) => prev - 10)
        i++
      }, 1000)

      return () => clearInterval(interval)
    }
  }, [isAnimate])

  return (
    <div className={styles.wheelContainer}>
      <img className={styles.wheelBg} src={wheelBgImage} alt={'Wheel background'} />
      <img className={styles.wheelCrown} src={wheelCrown} alt={'Wheel Crown'} />
      <img
        onClick={!disabled ? onSpin: undefined}
        className={styles.wheel}
        style={{
          transform: `rotate(${rotateBorderDegree}deg)`,
          transitionDuration: isAnimate ? '5.5s' : '1s',
          transitionTimingFunction: isAnimate ? 'cubic-bezier(0.45, 0.04, 0.13, 1)' : 'ease-in-out',
        }}
        src={i18n.language === 'ru' ? wheelImage : wheelImageKz}
        alt={'Wheel'}
      />
      <div className={styles.wheelArrowContainer}>
        <img className={styles.wheelArrow} src={wheelArrowImage} alt={'Arrow'} />
      </div>
    </div>
  )
}

export default memo(Wheel)
